import { render, staticRenderFns } from "./feature-chips.vue?vue&type=template&id=555f12d7&scoped=true&lang=pug&"
import script from "./feature-chips.vue?vue&type=script&lang=js&"
export * from "./feature-chips.vue?vue&type=script&lang=js&"
import style0 from "./feature-chips.vue?vue&type=style&index=0&id=555f12d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f12d7",
  null
  
)

/* custom blocks */
import block0 from "./feature-chips.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsChip: require('/home/ubuntu/nuxt/bonkers/releases/20231130131843/components/widgets/chip.vue').default})
